import { useCurrentPage } from 'services/url';

import { PAGES } from 'consts/pages';

import { useAiState } from './SearchProvider';
import useSearchAlternated from './useSearchAlternated';

const useDashboardSearchAlternated = ({
  pqlQuery,
  pqlAlternation,
  aiPrioritization = true,
  searchType,
  onSearchSuccess,
  transformResponse,
  runInBackground,
}) => {
  const aiCtx = useAiState();
  const page = useCurrentPage();
  const calculatedAlternation =
    (pqlAlternation &&
      aiPrioritization &&
      aiCtx.aiOn &&
      page === PAGES.events &&
      searchType === 'O_EVENTS' &&
      `${pqlAlternation} deviation_score > 9 or killchain = "MALICIOUS"`) ||
    pqlAlternation;

  return useSearchAlternated({
    pqlQuery,
    pqlAlternation: calculatedAlternation,
    searchType,
    onSearchSuccess,
    transformResponse,
    runInBackground,
  });
};

export default useDashboardSearchAlternated;
